import {Directive, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[appClickActions]'
})
export class ClickActionsDirective {

  private clickTimerId = -1;
  private clickTimerOn = false;

  private holdTimerId = -1;
  private lastActionWasHold = false;

  @Output() actClick = new EventEmitter<MouseEvent>();
  @Output() actDblClick = new EventEmitter<MouseEvent>();
  @Output() actHold = new EventEmitter<MouseEvent | TouchEvent>();

  constructor() { }

  @HostListener('click', ['event'])
  onClick(e: MouseEvent) {
    // en caso de que la ultima accion haya sido un hold, prevenimos el click.
    // Si no lo hacemos, luego del hold se va a disparar un evento click.
    if (this.lastActionWasHold) {
      this.lastActionWasHold = false;
      return;
    }

    // aqui manejaremos el click sin hold. si no hay timer, es la primera vez que hacemos click
    if (!this.clickTimerOn) {
      // activamos el timer de espera para el doble click
      this.clickTimerOn = true;
      this.clickTimerId = window.setTimeout(() => {
        // si el timer de espera se cumple, emitimos un solos click
        this.actClick.emit(e);
        this.clickTimerOn = false;
      }, 325)
    } else {
      // hay un timer de doble click en espera, enviamos un evento de doble click
      this.clickTimerOn = false;
      window.clearTimeout(this.clickTimerId);
      this.actDblClick.emit(e);
    }
  }

  // dado que para hacer un hold, debemos mantener el touch, el evento click no se dispara, por eso lo manejamos aparte
  @HostListener('touchstart')
  onTouchStart() {
    // cuando recibimos un evento mousedown, lanzamos un timer para el hold
    this.holdTimerId = window.setTimeout(() => {
      // una vez cumplido el tiempo de hold, lanzamos el evento
      this.actHold.emit();
      // si se cumple el hold, la ultima accion es Hold, por lo que la marcamos como tal
      this.lastActionWasHold = true;
    }, 800);
  }

  @HostListener('touchend')
  onTouchEnd() {
    // si no cumplimos el tiempo establecido, eliminamos el timer
    window.clearTimeout(this.holdTimerId);
  }



}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/click-actions.directive.ts